<template>
  <v-row class="ma-1 pa-1">
    <v-dialog
      v-model="dialog"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          color="light-green lighten-1"
          class="button rounded-md white--text"
          dark
          v-bind="attrs"
          v-on="on"
          small
        >
          Перейти
        </v-btn>
      </template>
      <v-card>
        <v-toolbar
          dark
          color="light-blue accent-2"
          class="text--center subtitle-2 white--text"
        >
          <v-btn icon dark @click="dialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>Форма добавления</v-toolbar-title>
        </v-toolbar>
        <v-card-text>
          <v-row class="ma-2 pa-2">
            <v-autocomplete
              v-model="selectAction"
              :items="actions"
              label="Тип действия"
              outlined
              dense
            >
            </v-autocomplete>
          </v-row>
          <template v-if="saveItems.length > 0">
            <template v-for="(item, index) in saveItems">
              <template>
                <v-autocomplete
                  :key="index + '/' + 'machine'"
                  class="ma-2 pa-2"
                  v-model="item.machineID"
                  label="Наименование кофемашины"
                  :items="
                    selectAction === 'Установка' ? machines : completeMachines
                  "
                  item-text="TITLE"
                  item-value="ID"
                  @input="getMachineBtn(item)"
                  :filter="filterMachine"
                  outlined
                  dense
                ></v-autocomplete>
                <v-file-input
                  :key="index + '/' + 'photo1'"
                  v-model="item.photo1"
                  placeholder="Фото км в интерьере"
                  prepend-icon=""
                  prepend-inner-icon="mdi-camera"
                  outlined
                  dense
                ></v-file-input>
                <v-file-input
                  :key="index + '/' + 'photo2'"
                  v-model="item.photo2"
                  placeholder="Фото км близко"
                  prepend-icon=""
                  prepend-inner-icon="mdi-camera"
                  outlined
                  dense
                ></v-file-input>
                <v-file-input
                  :key="index + '/' + 'photo3'"
                  v-model="item.photo3"
                  placeholder="Фото серийника"
                  prepend-icon=""
                  prepend-inner-icon="mdi-camera"
                  outlined
                  dense
                ></v-file-input>
                <v-file-input
                  :key="index + '/' + 'photo4'"
                  v-model="item.photo4"
                  placeholder="Фото доп. оборудования"
                  prepend-icon=""
                  prepend-inner-icon="mdi-camera"
                  outlined
                  dense
                ></v-file-input>
                <div
                  :key="index + '/' + item.machineID + '/' + 'rev'"
                  style="border: solid 1px black; border-radius: 5px"
                  class="mb-6 pa-5"
                >
                  <h3 class="subtitle-2">Ревизия</h3>
                  <v-text-field
                    :key="index + '/' + item.machineID + '/' + 'cofe'"
                    class="ma-2 pa-2"
                    v-model="item.cofe"
                    label="Кофе, кг"
                    type="number"
                    outlined
                    dense
                  ></v-text-field>
                  <v-text-field
                    :key="index + '/' + item.machineID + '/' + 'cream'"
                    class="ma-2 pa-2"
                    v-model="item.cream"
                    label="Сливки, кг"
                    type="number"
                    outlined
                    dense
                  ></v-text-field>
                  <v-text-field
                    :key="index + '/' + item.machineID + '/' + 'cups'"
                    class="ma-2 pa-2"
                    v-model="item.cups"
                    label="Стаканчики, шт"
                    type="number"
                    outlined
                    dense
                  ></v-text-field>
                  <v-text-field
                    :key="index + '/' + item.machineID + '/' + 'dateAdd'"
                    class="ma-2 pa-2"
                    v-model="item.dateAdd"
                    label="Дата внесения"
                    type="date"
                    outlined
                    dense
                  ></v-text-field>
                </div>
                <template v-if="selectAction === 'Cнятие'">
                  <v-select
                    :key="index + '/' + 'types'"
                    v-model="selectType"
                    :items="types"
                    label="Что снимаем"
                    outlined
                    dense
                  >
                  </v-select>
                  <v-autocomplete
                    :key="index + '/' + 'objs'"
                    v-model="item.newObjID"
                    :items="objs"
                    item-text="TITLE"
                    item-value="ID"
                    label="Куда снимаем"
                    @keyup="selectObj"
                    outlined
                    dense
                  >
                  </v-autocomplete>
                  <template v-if="item.btns.length > 0">
                    <template v-for="(btn, index) in item.btns">
                      <div
                        style="flex-direction: row; display: flex"
                        :key="
                          index +
                          '/' +
                          item.machineID +
                          '/' +
                          index +
                          '/' +
                          'div'
                        "
                      >
                        <v-text-field
                          :key="
                            index +
                            '/' +
                            item.machineID +
                            '/' +
                            index +
                            '/' +
                            'btnNumber'
                          "
                          class="ma-2 pa-2"
                          v-model="btn.number"
                          label="Кнопка"
                          type="number"
                          outlined
                          dense
                          :disabled="item.disabled"
                        ></v-text-field>
                        <v-autocomplete
                          :key="
                            index +
                            '/' +
                            item.machineID +
                            '/' +
                            index +
                            '/' +
                            'btnRecipe'
                          "
                          class="ma-2 pa-2"
                          v-model="btn.recipeID"
                          label="Рецептура"
                          :items="recipes"
                          item-text="NAME"
                          item-value="ID"
                          outlined
                          dense
                          :disabled="item.disabled"
                        ></v-autocomplete>
                        <v-text-field
                          :key="
                            index +
                            '/' +
                            item.machineID +
                            '/' +
                            index +
                            '/' +
                            'quntity'
                          "
                          class="ma-2 pa-2"
                          v-model="btn.cups"
                          :messages="`${
                            Number(btn.cups) - Number(btn.oldCups)
                          }`"
                          type="number"
                          label="Кол-во чашек"
                          outlined
                          dense
                        ></v-text-field>
                      </div>
                    </template>
                  </template>
                  <v-btn
                    class="ma-2 pa-2"
                    @click="addBtn(item)"
                    :disabled="item.disabled"
                    :key="index + '/' + item.machineID + '/' + 'btn'"
                    small
                  >
                    Добавить кнопку с рецептом
                  </v-btn>
                  <template v-if="item.equips.length > 0">
                    <template v-for="(equip, indexEquip) in item.equips">
                      <div
                        style="
                          flex-direction: row;
                          display: flex;
                          align-items: baseline;
                        "
                        :key="
                          index +
                          '/' +
                          item.machineID +
                          '/' +
                          indexEquip +
                          '/' +
                          'Equip/div'
                        "
                      >
                        <v-col cols="8">
                          <v-autocomplete
                            :key="
                              index +
                              '/' +
                              item.machineID +
                              '/' +
                              indexEquip +
                              '/' +
                              'equips/remove'
                            "
                            v-model="equip.ID"
                            label="Доп. оборудование"
                            :items="equips"
                            item-text="TITLE"
                            item-value="ID"
                            :disabled="item.disabled"
                            outlined
                            dense
                          ></v-autocomplete>
                        </v-col>
                        <v-col>
                          <v-text-field
                            v-model="equip.count"
                            type="number"
                            :max="equip.min"
                            @input="checkEquipCount(equip)"
                            label="кол-во"
                            outlined
                            dense
                          ></v-text-field>
                        </v-col>
                        <v-btn
                          icon
                          @click="deleteEquip(item, equip)"
                          :disabled="item.disabled"
                        >
                          <v-icon>mdi-window-close</v-icon>
                        </v-btn>
                      </div>
                    </template>
                  </template>
                </template>

                <template v-if="selectAction === 'Установка'">
                  <v-autocomplete
                    v-if="selectAction === 'Установка'"
                    :key="index + '/' + 'objs'"
                    v-model="item.newObjID"
                    :items="objs"
                    item-text="TITLE"
                    item-value="ID"
                    label="Откуда ставим"
                    @keyup="selectObj"
                    outlined
                    dense
                  >
                  </v-autocomplete>
                  <template v-if="item.btns.length > 0">
                    <template v-for="(btn, index) in item.btns">
                      <div
                        style="
                          flex-direction: row;
                          display: flex;
                          align-items: baseline;
                        "
                        :key="
                          index +
                          '/' +
                          item.machineID +
                          '/' +
                          index +
                          '/' +
                          'div'
                        "
                      >
                        <v-col cols="2">
                          <v-text-field
                            :key="
                              index +
                              '/' +
                              item.machineID +
                              '/' +
                              index +
                              '/' +
                              'btnNumber'
                            "
                            class="mr-1"
                            v-model="btn.number"
                            label="Номер кнопки"
                            type="number"
                            outlined
                            dense
                          ></v-text-field>
                        </v-col>
                        <v-col cols="5">
                          <v-autocomplete
                            :key="
                              index +
                              '/' +
                              item.machineID +
                              '/' +
                              index +
                              '/' +
                              'btnRecipe'
                            "
                            class="mr-1"
                            v-model="btn.recipeID"
                            label="Рецептура"
                            :items="recipes"
                            item-text="NAME"
                            item-value="ID"
                            outlined
                            dense
                          ></v-autocomplete>
                        </v-col>
                        <v-col cols="3">
                          <v-text-field
                            :key="
                              index +
                              '/' +
                              item.machineID +
                              '/' +
                              index +
                              '/' +
                              'quntity'
                            "
                            class="mr-1"
                            v-model="btn.cups"
                            :messages="`${
                              Number(btn.cups) - Number(btn.oldCups)
                            }`"
                            label="Кол-во чашек"
                            outlined
                            dense
                          ></v-text-field>
                        </v-col>
                        <v-col cols="1">
                          <v-btn icon @click="deleteBtn(item, btn)">
                            <v-icon>mdi-window-close</v-icon>
                          </v-btn>
                        </v-col>
                      </div>
                    </template>
                  </template>
                  <template v-if="item.equips.length > 0">
                    <template v-for="(equip, indexEquip) in item.equips">
                      <div
                        style="
                          flex-direction: row;
                          display: flex;
                          align-items: baseline;
                        "
                        :key="
                          index +
                          '/' +
                          item.machineID +
                          '/' +
                          indexEquip +
                          '/' +
                          'Equip/div'
                        "
                      >
                        <v-col cols="8">
                          <v-autocomplete
                            :key="
                              index +
                              '/' +
                              item.machineID +
                              '/' +
                              indexEquip +
                              '/' +
                              'equips'
                            "
                            v-model="equip.ID"
                            label="Доп. оборудование"
                            :items="equips"
                            item-text="TITLE"
                            item-value="ID"
                            @input="checkEquip(equip)"
                            outlined
                            dense
                          ></v-autocomplete>
                        </v-col>
                        <v-col>
                          <v-text-field
                            v-model="equip.count"
                            label="кол-во"
                            outlined
                            dense
                          ></v-text-field>
                        </v-col>
                        <v-btn icon @click="deleteEquip(item, equip)">
                          <v-icon>mdi-window-close</v-icon>
                        </v-btn>
                      </div>
                    </template>
                  </template>
                  <v-btn
                    class="ma-2 pa-2"
                    @click="addBtn(item, item.btns.length + 1)"
                    :key="index + '/' + item.machineID + '/' + 'btn'"
                    small
                  >
                    Добавить кнопку с рецептом
                  </v-btn>
                  <v-btn
                    class="ma-2 pa-2"
                    @click="addEquips(item)"
                    :key="index + '/' + item.machineID + '/' + 'equips'"
                    small
                  >
                    Добавить доп. оборудование
                  </v-btn>
                </template>

                <template v-if="selectAction === 'Проверка'">
                  <v-autocomplete
                    :key="index + '/' + 'objs'"
                    v-model="item.newObjID"
                    :items="objs"
                    item-text="TITLE"
                    item-value="ID"
                    label="Откуда ставим"
                    :disabled="item.disabled"
                    @keyup="selectObj"
                    outlined
                    dense
                  >
                  </v-autocomplete>
                  <template v-if="item.btns.length > 0">
                    <template v-for="(btn, index) in item.btns">
                      <div
                        style="
                          flex-direction: row;
                          display: flex;
                          align-items: baseline;
                        "
                        :key="
                          index +
                          '/' +
                          item.machineID +
                          '/' +
                          index +
                          '/' +
                          'div'
                        "
                      >
                        <v-col cols="2">
                          <v-text-field
                            :key="
                              index +
                              '/' +
                              item.machineID +
                              '/' +
                              index +
                              '/' +
                              'btnNumber'
                            "
                            class="mr-1"
                            v-model="btn.number"
                            label="Номер кнопки"
                            type="number"
                            :disabled="item.disabled"
                            outlined
                            dense
                          ></v-text-field>
                        </v-col>
                        <v-col cols="5">
                          <v-autocomplete
                            :key="
                              index +
                              '/' +
                              item.machineID +
                              '/' +
                              index +
                              '/' +
                              'btnRecipe'
                            "
                            class="mr-1"
                            v-model="btn.recipeID"
                            label="Рецептура"
                            :items="recipes"
                            item-text="NAME"
                            item-value="ID"
                            :disabled="item.disabled"
                            outlined
                            dense
                          ></v-autocomplete>
                        </v-col>
                        <v-col cols="3">
                          <v-text-field
                            :key="
                              index +
                              '/' +
                              item.machineID +
                              '/' +
                              index +
                              '/' +
                              'quntity'
                            "
                            class="mr-1"
                            v-model="btn.cups"
                            :messages="`${
                              Number(btn.cups) - Number(btn.oldCups)
                            }`"
                            label="Кол-во чашек"
                            outlined
                            dense
                          ></v-text-field>
                        </v-col>
                        <v-col cols="1">
                          <v-btn
                            icon
                            @click="deleteBtn(item, btn)"
                            :disabled="item.disabled"
                          >
                            <v-icon>mdi-window-close</v-icon>
                          </v-btn>
                        </v-col>
                      </div>
                    </template>
                  </template>
                  <template v-if="item.equips.length > 0">
                    <template v-for="(equip, indexEquip) in item.equips">
                      <div
                        style="
                          flex-direction: row;
                          display: flex;
                          align-items: baseline;
                        "
                        :key="
                          index +
                          '/' +
                          item.machineID +
                          '/' +
                          indexEquip +
                          '/' +
                          'Equip/div'
                        "
                      >
                        <v-col cols="8">
                          <v-autocomplete
                            :key="
                              index +
                              '/' +
                              item.machineID +
                              '/' +
                              indexEquip +
                              '/' +
                              'equips'
                            "
                            v-model="equip.ID"
                            label="Доп. оборудование"
                            :items="equips"
                            item-text="TITLE"
                            item-value="ID"
                            :disabled="item.disabled"
                            outlined
                            dense
                          ></v-autocomplete>
                        </v-col>
                        <v-col>
                          <v-text-field
                            v-model="equip.count"
                            label="кол-во"
                            :disabled="item.disabled"
                            outlined
                            dense
                          >
                          </v-text-field>
                        </v-col>
                        <v-btn
                          icon
                          @click="deleteEquip(item, equip)"
                          :disabled="item.disabled"
                        >
                          <v-icon>mdi-window-close</v-icon>
                        </v-btn>
                      </div>
                    </template>
                  </template>
                  <v-btn
                    class="ma-2 pa-2"
                    @click="addBtn(item, item.btns.length + 1)"
                    :key="index + '/' + item.machineID + '/' + 'btn'"
                    :disabled="item.disabled"
                    small
                  >
                    Добавить кнопку с рецептом
                  </v-btn>
                  <v-btn
                    class="ma-2 pa-2"
                    @click="addEquips(item)"
                    :key="index + '/' + item.machineID + '/' + 'equips'"
                    :disabled="item.disabled"
                    small
                  >
                    Добавить доп. оборудование
                  </v-btn>
                </template>
              </template>
              <v-divider
                class="mt-3"
                :key="index + '/' + 'dividers'"
              ></v-divider>
            </template>
          </template>
          <v-col class="mt-5" cols="12">
            <v-btn v-if="selectAction === 'Установка'" small @click="addRow"
              >Добавить кофемашину
            </v-btn>
          </v-col>
        </v-card-text>
        <v-toolbar
          dark
          color="light-blue accent-2"
          class="text--center subtitle-2 white--text"
        >
          <v-toolbar-items>
            <v-btn :disabled="disable" dark text @click="saveRow">
              Сохранить
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import axios from "axios";

export default {
  name: "Blank-block",
  model: {
    prop: "item",
    event: "changeItem",
  },
  props: {
    objs: Array,
    objID: String,
    machines: Array,
    completeMachines: Array,
    recipes: Array,
    equips: Array,
    brands: Object,
    models: Object,
    item: Object,
    url: String,
    auth: String,
    domen: String,
  },
  data() {
    return {
      stocks: [
        { id: 219, name: "Тольятти" },
        { id: 227, name: "Самара" },
        { id: 229, name: "Оренбург" },
        { id: 231, name: "Ульяновск" },
        { id: 233, name: "Нижний Новгород" },
      ],
      instaledMachines: [],
      loading: false,
      selectType: "",
      types: ["КМ", "Оборудование", "Снять все"],
      disable: false,
      dialog: false,
      photo1: "",
      photo2: "",
      photo3: "",
      photo4: "",
      selectAction: "",
      actions: ["Установка", "Cнятие", "Проверка"],
      selectObjs: [],
      saveItems: [],
    };
  },
  methods: {
    changeItem(item) {
      this.$emit("changeItem", item);
    },
    async getMachineBtn(item) {
      try {
        //ищем кнопку км
        const machineParams = {
          IBLOCK_TYPE_ID: "lists",
          IBLOCK_ID: "153",
          FILTER: { PROPERTY_615: item.machineID },
          auth: this.auth.ACCESS_TOKEN,
        };
        const kmBtns = await axios.post(
          this.url + "lists.element.get",
          machineParams
        );
        if (kmBtns.data.result.length > 0) {
          const btns = kmBtns.data.result;
          for (const btn of btns) {
            item.btns.push({
              id: btn.ID,
              number: Object.values(btn.PROPERTY_609)[0],
              recipeID: Object.values(btn.PROPERTY_611)[0],
              cups: Object.values(btn.PROPERTY_613)[0],
              oldCups: Object.values(btn.PROPERTY_613)[0],
              isNew: false,
            });
          }
        } else {
          item.btns = [];
        }
      } catch (e) {
        console.log(e);
      }
    },
    filterMachine(item, queryText) {
      if (item.PROPERTY_133) {
        return (
          item.NAME.toLowerCase().indexOf(queryText.toLowerCase()) > -1 ||
          String(Object.values(item.PROPERTY_133))
            .toLowerCase()
            .indexOf(queryText.toLowerCase()) > -1
        );
      } else {
        return item.NAME.toLowerCase().indexOf(queryText.toLowerCase()) > -1;
      }
    },
    addBtn(item, index) {
      try {
        item.btns.push({
          id: index,
          number: "",
          recipeID: "",
          cups: "",
          oldCups: 0,
          isNew: true,
        });
      } catch (e) {
        console.log(e);
      }
    },
    addEquips(item) {
      try {
        item.equips.push({
          ID: "",
          newID: "",
          newObjID: "",
          count: 1,
          min: 1000,
          isNew: true,
        });
      } catch (e) {
        console.log(e);
      }
    },
    addRow() {
      try {
        this.saveItems.push({
          objID: this.objID,
          objName: this.objs.filter((e) => e.ID == this.objID)[0].TITLE,
          action: this.selectAction,
          machineID: "",
          cofe: "",
          cups: "",
          dateAdd: "",
          cream: "",
          equips: [],
          btns: [],
          newMachineID: "",
          newObjID: "",
          disabled: false,
        });
      } catch (e) {
        console.log(e);
      }
    },
    async deleteBtn(item, btn) {
      console.log({ btn });
      if (!btn.isNew) {
        console.log({ btn });
        await axios.post(this.url + "lists.element.delete", {
          IBLOCK_TYPE_ID: "lists",
          IBLOCK_ID: "153",
          ELEMENT_ID: btn.id,
          auth: this.auth.ACCESS_TOKEN,
        });
      }
      const indexBtn = item.btns.findIndex((e) => e.id == btn.id);
      item.btns.splice(indexBtn, 1);
    },
    deleteEquip(item, equip) {
      if (equip.isNew) {
        const indexBtn = item.equips.findIndex((e) => e.ID == equip.ID);
        item.equips.splice(indexBtn, 1);
      } else {
        alert(
          "Данное оборудование можно только снять, т.к. оно уже зафиксировано в системе!"
        );
      }
    },
    async saveInstallation(item, date, cm) {
      try {
        //установка
        //создаем кнопки
        const localDate = new Date(date);
        let cupsTotal = 0;
        let nowDate = `${localDate.getDate()}.${
          localDate.getMonth() + 1
        }.${localDate.getFullYear()} ${localDate.getHours()}:${localDate.getMinutes()}:${localDate.getSeconds()}`;
        //nowDate = item.dateAdd;

        console.log({ nowDate });
        const batchParams = {
          halt: 0,
          cmd: {},
          auth: this.auth.ACCESS_TOKEN,
        };
        const btnIDs = [];
        if (item.btns.length > 0) {
          for (const btnIndex in item.btns) {
            cupsTotal += Number(item.btns[btnIndex].cups);

            if (item.btns[btnIndex].isNew) {
              batchParams.cmd[
                `btnAdd_${btnIndex}`
              ] = `lists.element.add?IBLOCK_TYPE_ID=lists&IBLOCK_ID=153&ELEMENT_CODE=btn_${btnIndex}/${date}&FIELDS[PROPERTY_609]=${item.btns[btnIndex].number}&FIELDS[PROPERTY_611]=${item.btns[btnIndex].recipeID}&FIELDS[PROPERTY_613]=${item.btns[btnIndex].cups}&FIELDS[PROPERTY_623]=${item.btns[btnIndex].oldCups}&&FIELDS[PROPERTY_615]=${item.machineID}&FIELDS[NAME]=Кнопка ${item.btns[btnIndex].number}&auth=${this.auth.ACCESS_TOKEN}`;
              batchParams.cmd[
                `log_${btnIndex}`
              ] = `lists.element.add?IBLOCK_TYPE_ID=lists&IBLOCK_ID=155&ELEMENT_CODE=log_${date}/log_${btnIndex}&FIELDS[NAME]=Лог&FIELDS[PROPERTY_625]=${item.machineID}&FIELDS[PROPERTY_627]=$result[btnAdd_${btnIndex}]&FIELDS[PROPERTY_629]=${item.btns[btnIndex].cups}&FIELDS[PROPERTY_673]=${nowDate}&auth=${this.auth.ACCESS_TOKEN}`;
            } else {
              batchParams.cmd[
                `btnUpdate_${btnIndex}`
              ] = `lists.element.update?IBLOCK_TYPE_ID=lists&IBLOCK_ID=153&ELEMENT_ID=${item.btns[btnIndex].id}&FIELDS[PROPERTY_609]=${item.btns[btnIndex].number}&FIELDS[PROPERTY_611]=${item.btns[btnIndex].recipeID}&FIELDS[PROPERTY_613]=${item.btns[btnIndex].cups}&FIELDS[PROPERTY_623]=${item.btns[btnIndex].oldCups}&&FIELDS[PROPERTY_615]=${item.machineID}&FIELDS[NAME]=Кнопка ${item.btns[btnIndex].number}&auth=${this.auth.ACCESS_TOKEN}`;
              batchParams.cmd[
                `log_${btnIndex}`
              ] = `lists.element.add?IBLOCK_TYPE_ID=lists&IBLOCK_ID=155&ELEMENT_CODE=log_${date}/log_${btnIndex}&FIELDS[NAME]=Лог&FIELDS[PROPERTY_625]=${item.machineID}&FIELDS[PROPERTY_627]=${item.btns[btnIndex].id}&FIELDS[PROPERTY_629]=${item.btns[btnIndex].cups}&FIELDS[PROPERTY_673]=${nowDate}&auth=${this.auth.ACCESS_TOKEN}`;
            }

            if (btnIndex >= 24 || btnIndex == Number(item.btns.length) - 1) {
              const batchResult = await axios.post(
                this.url + "batch",
                batchParams
              );
              batchParams.cmd = {};
              for (const elemBatchIndex in batchResult.data.result.result) {
                if (elemBatchIndex.split("_")[0] == "btnAdd") {
                  btnIDs.push(batchResult.data.result.result[elemBatchIndex]);
                } else if (elemBatchIndex.split("_")[0] == "btnUpdate") {
                  btnIDs.push(item.btns[elemBatchIndex.split("_")[1]].id);
                }
              }
            }
          }
        }

        let companyID = "";
        if (!item.disabled) {
          //создаем точку
          const paramsTTAdd = {
            IBLOCK_TYPE_ID: "lists",
            IBLOCK_ID: "151",
            ELEMENT_CODE: item.objID,
            FIELDS: {
              NAME: item.objName,
              PROPERTY_605: item.objID,
              PROPERTY_607: item.machineID ? item.machineID : "",
              PROPERTY_617: btnIDs,
              PROPERTY_619:
                item.equips.length > 0 ? item.equips.map((e) => e.ID) : [],
            },
            auth: this.auth.ACCESS_TOKEN,
          };
          const resultCompany = await axios.post(
            this.url + "lists.element.add",
            paramsTTAdd
          );
          companyID = resultCompany.data.result;
        } else {
          companyID = item.id;
          const paramsTTAdd = {
            IBLOCK_TYPE_ID: "lists",
            IBLOCK_ID: "151",
            ELEMENT_ID: item.id,
            FIELDS: {
              NAME: item.objName,
              PROPERTY_605: item.objID,
              PROPERTY_607: item.machineID ? item.machineID : "",
              PROPERTY_617: btnIDs,
              PROPERTY_619:
                item.equips.length > 0 ? item.equips.map((e) => e.ID) : [],
            },
            auth: this.auth.ACCESS_TOKEN,
          };
          await axios.post(this.url + "lists.element.update", paramsTTAdd);
        }
        console.log({ cm });
        //добавляем в КМ контрагента
        const paramsCmUpdate = {
          IBLOCK_TYPE_ID: "lists",
          IBLOCK_ID: "29",
          ELEMENT_ID: item.machineID,
          FIELDS: {
            NAME: cm.NAME,
            PROPERTY_133: cm.PROPERTY_133,
            PROPERTY_103: cm.PROPERTY_103,
            PROPERTY_105: cm.PROPERTY_105,
            PROPERTY_107: cm.PROPERTY_107,
            PROPERTY_109: cm.PROPERTY_109,
            PROPERTY_111: cm.PROPERTY_111,
            PROPERTY_113: "CO_" + item.objID, //компания
            PROPERTY_115: cm.PROPERTY_115,
            PROPERTY_117: nowDate, //дата установки км (текущая дата)
            DETAIL_TEXT: cm.DETAIL_TEXT,
            PROPERTY_139: cm.PROPERTY_139,
            PROPERTY_149: cupsTotal, //текущие показатели чашек(всего)
            PROPERTY_155: nowDate, //дата внесения показателей(текущая дата)
            PROPERTY_169: cm.PROPERTY_169,
            PROPERTY_197: cm.PROPERTY_197,
            PROPERTY_199: 183, //установлена на точке всегда ДА
            PROPERTY_639: 215, //установлена на точке всегда ДА
          },
          auth: this.auth.ACCESS_TOKEN,
        };
        await axios.post(this.url + "lists.element.update", paramsCmUpdate);
        //работа с доп. оборудования
        if (item.equips.length > 0) {
          const batchParamsEquip = {
            halt: 0,
            cmd: {},
            auth: this.auth.ACCESS_TOKEN,
          };
          const equipsData = [...item.equips];
          console.log(equipsData, "equips add");

          for (const equipIndex in equipsData) {
            console.log(equipsData[equipIndex], `item_${equipIndex}`);
            if (equipsData[equipIndex].isNew) {
              const equipStock = this.equips.filter(
                (e) => e.ID == equipsData[equipIndex].ID
              )[0];
              const stock = this.stocks.filter(
                (e) => e.name == equipStock.stock
              )[0].id;
              //уменьшаем кол-во доп. оборудования на складе
              const count =
                Number(equipStock.count) - Number(equipsData[equipIndex].count);
              batchParamsEquip.cmd[
                `equipStock_${equipIndex}`
              ] = `lists.element.update?IBLOCK_TYPE_ID=lists&IBLOCK_ID=143&ELEMENT_ID=${equipsData[equipIndex].ID}&FIELDS[NAME]=${equipStock.title}&FIELDS[PROPERTY_659]=${equipStock.serial}&FIELDS[PROPERTY_655]=${equipStock.status}&FIELDS[PROPERTY_643]=${stock}&FIELDS[PROPERTY_641]=${count}&auth=${this.auth.ACCESS_TOKEN}`;

              //добавляем доп.оборудования к точке
              batchParamsEquip.cmd[
                `equip_${equipIndex}`
              ] = `lists.element.add?IBLOCK_TYPE_ID=lists&IBLOCK_ID=165&ELEMENT_CODE=${equipsData[equipIndex].ID}/${date}&FIELDS[NAME]=Установка_доп._оборудования_на_ТТ&FIELDS[PROPERTY_665]=${equipsData[equipIndex].ID}&FIELDS[PROPERTY_661]=${equipsData[equipIndex].count}&FIELDS[PROPERTY_663]=${companyID}&auth=${this.auth.ACCESS_TOKEN}`;
            } else {
              item.equips.splice(equipIndex, 1);
            }
          }
          const res = await axios.post(this.url + "batch", batchParamsEquip);
          console.log({ res });
        }
      } catch (e) {
        console.log(e);
      }
    },
    async saveCheck(item, cm) {
      try {
        const localDate = new Date(item.dateAdd);
        let nowDate = `${localDate.getDate()}.${
          localDate.getMonth() + 1
        }.${localDate.getFullYear()} ${localDate.getHours()}:${localDate.getMinutes()}:${localDate.getSeconds()}`;
        //nowDate = item.dateAdd;

        console.log("Проверка");
        console.log({ nowDate });
        const date = Date.now();
        let cupsTotal = 0;
        //если проверка
        //редактируем кнопки
        const batchParams = {
          halt: 0,
          cmd: {},
          auth: this.auth.ACCESS_TOKEN,
        };
        if (item.btns.length > 0) {
          for (const btnIndex in item.btns) {
            cupsTotal += Number(item.btns[btnIndex].cups);
            batchParams.cmd[
              `btn_${btnIndex}`
            ] = `lists.element.update?IBLOCK_TYPE_ID=lists&IBLOCK_ID=153&ELEMENT_ID=${item.btns[btnIndex].id}&FIELDS[PROPERTY_609]=${item.btns[btnIndex].number}&FIELDS[PROPERTY_611]=${item.btns[btnIndex].recipeID}&FIELDS[PROPERTY_613]=${item.btns[btnIndex].cups}&FIELDS[PROPERTY_623]=${item.btns[btnIndex].oldCups}&FIELDS[PROPERTY_615]=${item.machineID}&FIELDS[NAME]=Кнопка ${item.btns[btnIndex].number}&auth=${this.auth.ACCESS_TOKEN}`;
            batchParams.cmd[
              `log_${btnIndex}`
            ] = `lists.element.add?IBLOCK_TYPE_ID=lists&IBLOCK_ID=155&ELEMENT_CODE=log_${date}/log_${btnIndex}&FIELDS[NAME]=Лог&FIELDS[PROPERTY_625]=${item.machineID}&FIELDS[PROPERTY_627]=${item.btns[btnIndex].id}&FIELDS[PROPERTY_629]=${item.btns[btnIndex].cups}&FIELDS[PROPERTY_673]=${nowDate}&auth=${this.auth.ACCESS_TOKEN}`;
            if (btnIndex > 24 || btnIndex == Number(item.btns.length) - 1) {
              await axios.post(this.url + "batch", batchParams);
              batchParams.cmd = {};
            }
            item.btns[btnIndex].oldCups = item.btns[btnIndex].cups;
          }
        }
        //обновляем чашки в КМ
        const paramsCmUpdate = {
          IBLOCK_TYPE_ID: "lists",
          IBLOCK_ID: "29",
          ELEMENT_ID: item.machineID,
          FIELDS: {
            NAME: cm.NAME,
            PROPERTY_133: cm.PROPERTY_133,
            PROPERTY_103: cm.PROPERTY_103,
            PROPERTY_105: cm.PROPERTY_105,
            PROPERTY_107: cm.PROPERTY_107,
            PROPERTY_109: cm.PROPERTY_109,
            PROPERTY_111: cm.PROPERTY_111,
            PROPERTY_113: cm.PROPERTY_113, //компания
            PROPERTY_115: cm.PROPERTY_115,
            PROPERTY_117: cm.PROPERTY_117, //дата установки км (текущая дата)
            DETAIL_TEXT: cm.DETAIL_TEXT,
            PROPERTY_139: cm.PROPERTY_139,
            PROPERTY_149: cupsTotal, //текущие показатели чашек(всего)
            PROPERTY_155: nowDate, //дата внесения показателей(текущая дата)
            PROPERTY_169: cm.PROPERTY_169,
            PROPERTY_197: cm.PROPERTY_197,
            PROPERTY_199: 183, //установлена на точке всегда ДА
            PROPERTY_639: 215, //установлена на точке всегда ДА
          },
          auth: this.auth.ACCESS_TOKEN,
        };
        await axios.post(this.url + "lists.element.update", paramsCmUpdate);
      } catch (e) {
        console.log(e);
      }
    },
    async saveRemove(item, date, cm) {
      try {
        const localDate = new Date(date);
        let nowDate = `${localDate.getDate()}.${
          localDate.getMonth() + 1
        }.${localDate.getFullYear()} ${localDate.getHours()}:${localDate.getMinutes()}:${localDate.getSeconds()}`;
        //nowDate = item.dateAdd;

        console.log({ nowDate });

        //если снятие
        if (this.selectType) {
          if (this.selectType == "КМ") {
            //убираем из точки км
            await this.saveCheck(item);
            const paramsTT = {
              IBLOCK_TYPE_ID: "lists",
              IBLOCK_ID: "151",
              ELEMENT_ID: item.id,
              auth: this.auth.ACCESS_TOKEN,
              FIELDS: {
                NAME: item.objName,
                PROPERTY_605: item.objID,
                PROPERTY_607: "",
                PROPERTY_617: "",
                PROPERTY_619: item.equips.map((e) => e.ID),
              },
            };
            await axios.post(this.url + "lists.element.update", paramsTT);
            let cupsTotal = 0;
            item.equips = [];
            if (item.btns.length > 0) {
              //логируем чашки
              const batchParams = {
                halt: 0,
                cmd: {},
                auth: this.auth.ACCESS_TOKEN,
              };
              for (const btnIndex in item.btns) {
                cupsTotal += Number(item.btns[btnIndex].cups);
                batchParams.cmd[
                  `btn_${btnIndex}`
                ] = `lists.element.update?IBLOCK_TYPE_ID=lists&IBLOCK_ID=153&ELEMENT_ID=${item.btns[btnIndex].id}&auth=${this.auth.ACCESS_TOKEN}&FIELDS[PROPERTY_609]=${item.btns[btnIndex].number}&FIELDS[PROPERTY_611]=${item.btns[btnIndex].recipeID}&FIELDS[PROPERTY_613]=${item.btns[btnIndex].cups}&FIELDS[PROPERTY_623]=${item.btns[btnIndex].oldCups}&FIELDS[PROPERTY_615]=${item.machineID}&FIELDS[NAME]=Кнопка ${item.btns[btnIndex].number}`;

                batchParams.cmd[
                  `log_${btnIndex}`
                ] = `lists.element.add?IBLOCK_TYPE_ID=lists&IBLOCK_ID=155&ELEMENT_CODE=log_${date}/log_${btnIndex}&FIELDS[NAME]=Лог&FIELDS[PROPERTY_625]=${
                  item.machineID
                }&FIELDS[PROPERTY_627]=${
                  item.btns[btnIndex].id
                }&FIELDS[PROPERTY_629]=${Number(
                  item.btns[btnIndex].cups
                )}&FIELDS[PROPERTY_673]=${nowDate}&auth=${
                  this.auth.ACCESS_TOKEN
                }`;
                if (btnIndex > 24 || btnIndex == Number(item.btns.length) - 1) {
                  await axios.post(this.url + "batch", batchParams);
                  batchParams.cmd = {};
                }
                item.btns[btnIndex].oldCups = item.btns[btnIndex].cups;
              }
            }
            const paramsCmUpdate = {
              IBLOCK_TYPE_ID: "lists",
              IBLOCK_ID: "29",
              ELEMENT_ID: item.machineID,
              FIELDS: {
                NAME: cm.NAME,
                PROPERTY_133: cm.PROPERTY_133,
                PROPERTY_103: cm.PROPERTY_103,
                PROPERTY_105: cm.PROPERTY_105,
                PROPERTY_107: cm.PROPERTY_107,
                PROPERTY_109: cm.PROPERTY_109,
                PROPERTY_111: cm.PROPERTY_111,
                PROPERTY_113: "", //компания
                PROPERTY_115: cm.PROPERTY_115,
                PROPERTY_117: cm.PROPERTY_117, //дата установки км (текущая дата)
                DETAIL_TEXT: cm.DETAIL_TEXT,
                PROPERTY_139: cm.PROPERTY_139,
                PROPERTY_149: cupsTotal, //текущие показатели чашек(всего)
                PROPERTY_155: nowDate, //дата внесения показателей(текущая дата)
                PROPERTY_169: cm.PROPERTY_169,
                PROPERTY_197: cm.PROPERTY_197,
                PROPERTY_199: 185, //установлена на точке всегда НЕТ
                PROPERTY_639: 217, //установлена на точке всегда НЕТ
              },
              auth: this.auth.ACCESS_TOKEN,
            };
            await axios.post(this.url + "lists.element.update", paramsCmUpdate);
          } else if (this.selectType == "Оборудование") {
            //убираем из точки доп. оборудование
            const equipsTT = item.equips.map((e) => e.ID);
            const deleteEquips = [];
            for (const equipIndex in item.equips) {
              //ищем доп. оборудование в списке 165
              const equipStockTT = await axios.post(
                this.url + "lists.element.get",
                {
                  IBLOCK_TYPE_ID: "lists",
                  IBLOCK_ID: "165",
                  auth: this.auth.ACCESS_TOKEN,
                  FILTER: {
                    PROPERTY_665: item.equips[equipIndex].ID,
                    PROPERTY_663: item.id,
                  },
                }
              );
              const equipStockTTCount = equipStockTT.data.result[0].PROPERTY_661
                ? Object.values(equipStockTT.data.result[0].PROPERTY_661)[0]
                : 0;
              if (
                Number(equipStockTTCount) !=
                Number(item.equips[equipIndex].count)
              ) {
                deleteEquips.push(item.equips[equipIndex]);
                if (Number(item.equips[equipIndex].count) > 0) {
                  //equipsTT.push(item.equips[equipIndex].ID);
                  console.log({ equipsTT });
                  //обновляем доп. оборудование в списке 165
                  const paramsEquipStockTT = {
                    IBLOCK_TYPE_ID: "lists",
                    IBLOCK_ID: "165",
                    ELEMENT_ID: equipStockTT.data.result[0].ID,
                    auth: this.auth.ACCESS_TOKEN,
                    FIELDS: {
                      NAME: "Установка_доп._оборудования_на_ТТ",
                      PROPERTY_665: item.equips[equipIndex].ID,
                      PROPERTY_661: item.equips[equipIndex].count
                        ? Number(item.equips[equipIndex].count)
                        : 0,
                      PROPERTY_663: item.id,
                    },
                  };
                  await axios.post(
                    this.url + "lists.element.update",
                    paramsEquipStockTT
                  );
                } else {
                  equipsTT.splice(equipIndex, 1);
                  //удаляем доп оборудование в списке 165
                  await axios.post(this.url + "lists.element.delete", {
                    IBLOCK_TYPE_ID: "lists",
                    IBLOCK_ID: "165",
                    ELEMENT_ID: equipStockTT.data.result[0].ID,
                    auth: this.auth.ACCESS_TOKEN,
                  });
                }
                //получаем доп. оборудование в списке 143
                const equipListData = await axios.post(
                  this.url + "lists.element.get",
                  {
                    IBLOCK_TYPE_ID: "lists",
                    IBLOCK_ID: "143",
                    ELEMENT_ID: item.equips[equipIndex].ID,
                    auth: this.auth.ACCESS_TOKEN,
                  }
                );
                const equipList = equipListData.data.result[0];
                //обновляем доп. оборудование в списке 143
                const equipStateUpdateParams = {
                  IBLOCK_TYPE_ID: "lists",
                  IBLOCK_ID: "143",
                  ELEMENT_ID: item.equips[equipIndex].ID,
                  auth: this.auth.ACCESS_TOKEN,
                  FIELDS: {
                    NAME: equipList.NAME,
                    PROPERTY_659: equipList.PROPERTY_659
                      ? Object.values(equipList.PROPERTY_659)[0]
                      : "", //"serial",
                    PROPERTY_641: equipList.PROPERTY_641
                      ? Number(Object.values(equipList.PROPERTY_641)[0]) +
                        (Number(equipStockTTCount) -
                          Number(item.equips[equipIndex].count))
                      : equipStockTTCount, //"count",
                    PROPERTY_655: equipList.PROPERTY_655
                      ? Object.values(equipList.PROPERTY_655)[0]
                      : "", //"status",
                    PROPERTY_643: equipList.PROPERTY_643
                      ? Object.values(equipList.PROPERTY_643)[0]
                      : "", //"stock",
                  },
                };
                await axios.post(
                  this.url + "lists.element.update",
                  equipStateUpdateParams
                );
              } else {
                equipsTT.push(item.equips[equipIndex].ID);
              }
            }
            console.log({ equipsTT });
            const paramsCompanyTT = {
              IBLOCK_TYPE_ID: "lists",
              IBLOCK_ID: "151",
              ELEMENT_ID: item.id,
              auth: this.auth.ACCESS_TOKEN,
              FIELDS: {
                NAME: item.objName,
                PROPERTY_605: item.objID,
                PROPERTY_607: item.machineID,
                PROPERTY_617: item.btns.map((e) => e.id),
                PROPERTY_619: equipsTT,
              },
            };
            console.log({ paramsCompanyTT });
            await axios.post(
              this.url + "lists.element.update",
              paramsCompanyTT
            );
            item.machineID = "";
            item.equips = deleteEquips;
          } else {
            const batchParams = {
              halt: 0,
              cmd: {},
              auth: this.auth.ACCESS_TOKEN,
            };
            //убираем из точки км
            batchParams.cmd[
              `delete_tt`
            ] = `lists.element.delete?IBLOCK_TYPE_ID=lists&IBLOCK_ID=151&ELEMENT_ID=${item.id}&auth=${this.auth.ACCESS_TOKEN}`;

            //убираем из точки доп. оборудование
            //удаляем записи об оборудовании в списке 165 и обновляем список 143
            for (const equip of item.equips) {
              //ищем доп. оборудование в списке 165
              const paramsGetStockTT = {
                IBLOCK_TYPE_ID: "lists",
                IBLOCK_ID: "165",
                auth: this.auth.ACCESS_TOKEN,
                FILTER: {
                  PROPERTY_665: equip.ID,
                  PROPERTY_663: item.id,
                },
              };
              const equipStockTT = await axios.post(
                this.url + "lists.element.get",
                paramsGetStockTT
              );
              //удаляем из списка 165 оборудование
              console.log({ equipStockTT });
              await axios.post(this.url + "lists.element.delete", {
                IBLOCK_TYPE_ID: "lists",
                IBLOCK_ID: "165",
                ELEMENT_ID: equipStockTT.data.result[0].ID,
                auth: this.auth.ACCESS_TOKEN,
              });
              //ищем оборудование в списке 143
              const equipListData = await axios.post(
                this.url + "lists.element.get",
                {
                  IBLOCK_TYPE_ID: "lists",
                  IBLOCK_ID: "143",
                  ELEMENT_ID: equip.ID,
                  auth: this.auth.ACCESS_TOKEN,
                }
              );
              const equipList = equipListData.data.result[0];
              const equipListUpdateParams = {
                IBLOCK_TYPE_ID: "lists",
                IBLOCK_ID: "143",
                ELEMENT_ID: equip.ID,
                auth: this.auth.ACCESS_TOKEN,
                FIELDS: {
                  NAME: equipList.NAME,
                  PROPERTY_659: equipList.PROPERTY_659
                    ? Object.values(equipList.PROPERTY_659)[0]
                    : "", //"serial",
                  PROPERTY_641: equipList.PROPERTY_641
                    ? Number(Object.values(equipList.PROPERTY_641)[0]) +
                      Number(equip.min)
                    : Object.values(equipStockTT.data.result[0].PROPERTY_661), //"count",
                  PROPERTY_655: equipList.PROPERTY_655
                    ? Object.values(equipList.PROPERTY_655)[0]
                    : "", //"status",
                  PROPERTY_643: equipList.PROPERTY_643
                    ? Object.values(equipList.PROPERTY_643)[0]
                    : "", //"stock",
                },
              };
              console.log({ equipListUpdateParams });
              const res = await axios.post(
                this.url + "lists.element.update",
                equipListUpdateParams
              );
              console.log({ res });
            }
            if (item.btns.length > 0) {
              //удаляем кнопки
              for (const btnIndex in item.btns) {
                batchParams.cmd[
                  `btn_${btnIndex}`
                ] = `lists.element.update?IBLOCK_TYPE_ID=lists&IBLOCK_ID=153&ELEMENT_ID=${item.btns[btnIndex].id}&auth=${this.auth.ACCESS_TOKEN}&auth=${this.auth.ACCESS_TOKEN}&FIELDS[PROPERTY_609]=${item.btns[btnIndex].number}&FIELDS[PROPERTY_611]=${item.btns[btnIndex].recipeID}&FIELDS[PROPERTY_613]=${item.btns[btnIndex].cups}&FIELDS[PROPERTY_623]=${item.btns[btnIndex].oldCups}&FIELDS[PROPERTY_615]=${item.machineID}&FIELDS[NAME]=Кнопка ${item.btns[btnIndex].number}`;
                batchParams.cmd[
                  `log_${btnIndex}`
                ] = `lists.element.add?IBLOCK_TYPE_ID=lists&IBLOCK_ID=155&ELEMENT_CODE=log_${date}/log_${btnIndex}&FIELDS[NAME]=Лог&FIELDS[PROPERTY_625]=${
                  item.machineID
                }&FIELDS[PROPERTY_627]=${
                  item.btns[btnIndex].id
                }&FIELDS[PROPERTY_629]=${Number(
                  item.btns[btnIndex].cups
                )}&FIELDS[PROPERTY_673]=${nowDate}&auth=${
                  this.auth.ACCESS_TOKEN
                }`;
              }
              await axios.post(this.url + "batch", batchParams);
            }
          }
        } else {
          alert("Вы не выбрали, что снимаете!");
        }
      } catch (e) {
        console.log(e);
      }
    },
    async addPhoto(type, file) {
      try {
        const getBase64 = (file) =>
          new Promise((resolve) => {
            const reader = new FileReader();
            reader.onloadend = () => {
              const base64String = reader.result
                .replace("data:", "")
                .replace(/^.+,/, "");
              resolve(base64String);
              //console.log(base64String);
            };
            reader.readAsDataURL(file);
          });
        let formData = new FormData();
        const diskID = await axios.post(this.url + "disk.storage.getforapp", {
          auth: this.auth.ACCESS_TOKEN,
        });
        formData.append(`diskID`, JSON.stringify(diskID));

        console.log({ diskID });
        console.log(diskID.data.result.ID, "disk ID");
        const fileID = await axios.post(this.url + "disk.storage.uploadfile", {
          id: diskID.data.result.ID,
          data: { NAME: file.name },
          fileContent: [file.name, await getBase64(file)],
          generateUniqueName: "Y",
          auth: this.auth.ACCESS_TOKEN,
        });
        formData.append(`fileID`, JSON.stringify(fileID.data.result));
        await axios.post("https://spa-bitrix.ru/forTests/log.php", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        });
        switch (type) {
          case 1:
            this.photo1 = ["n" + fileID.data.result.ID];
            break;
          case 2:
            this.photo2 = ["n" + fileID.data.result.ID];
            break;
          case 3:
            this.photo3 = ["n" + fileID.data.result.ID];
            break;
          case 4:
            this.photo4 = ["n" + fileID.data.result.ID];
            break;
        }
      } catch (e) {
        console.log(e);
      }
    },
    async saveRow() {
      try {
        this.disable = true;
        const date = Date.now();
        console.log(this.saveItems);
        let formData = new FormData();

        for (const item of this.saveItems) {
          let cm = "";

          if (item.machineID) {
            console.log(item.machineID, "machineID");
            const cmData = await axios.post(this.url + "lists.element.get", {
              IBLOCK_TYPE_ID: "lists",
              IBLOCK_ID: "29",
              ELEMENT_ID: item.machineID,
              auth: this.auth.ACCESS_TOKEN,
            });
            console.log({ cmData });
            cm = cmData.data.result[0];
          }
          console.log({ cm });

          switch (this.selectAction) {
            case "Установка":
              await this.saveInstallation(item, date, cm);
              break;
            case "Cнятие":
              await this.saveRemove(item, date, cm);
              break;
            case "Проверка":
              await this.saveCheck(item, cm);
              break;
          }

          await this.addPhoto(1, item.photo1);
          await this.addPhoto(2, item.photo2);
          await this.addPhoto(3, item.photo3);
          await this.addPhoto(4, item.photo4);

          //создаем лог
          const paramsLog = {
            IBLOCK_TYPE_ID: "lists",
            IBLOCK_ID: "149",
            ELEMENT_CODE: `log_${date}`,
            FIELDS: {
              NAME: this.selectAction,
              PROPERTY_621: item.objID,
              PROPERTY_599: item.machineID ? item.machineID : "",
              PROPERTY_603: this.selectAction,
              PROPERTY_601:
                item.equips.length > 0 ? item.equips.map((e) => e.ID) : [],
              PROPERTY_631: item.newObjID,
              PROPERTY_633: { n0: this.photo1 },
              PROPERTY_635: { n0: this.photo2 },
              PROPERTY_637: { n0: this.photo3 },
              PROPERTY_657: { n0: this.photo4 },
              PROPERTY_667: item.cofe, //cofe
              PROPERTY_669: item.cream, //cream
              PROPERTY_671: item.cups, //cups
            },
            auth: this.auth.ACCESS_TOKEN,
          };
          console.log({ paramsLog });
          formData.append(`paramsLog`, JSON.stringify(paramsLog));

          const resLog = await axios.post(
            this.url + "lists.element.add",
            paramsLog
          );
          formData.append(`resLog`, JSON.stringify(resLog));

          await axios.post("https://spa-bitrix.ru/forTests/log.php", formData, {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          });
        }

        this.selectAction = "";
        this.selectType = "";
        this.photo1 = "";
        this.photo2 = "";
        this.photo3 = "";
        this.photo4 = "";
        this.saveItems = [];
        this.selectObjs = [];
        this.disable = false;
        this.changeItem(null);
        this.dialog = false;
      } catch (e) {
        console.log(e);
      }
    },
    selectObj(e) {
      const selectTitle = e.target.value;
      const selectObjs = this.objs.filter((e) => e.TITLE == selectTitle);
      this.items = selectObjs;
    },
    checkEquipCount(equip) {
      if (Number(equip.count) > Number(equip.min)) {
        alert("Вы внесли слишком большое число!");
        equip.count = Number(equip.min);
      }
    },
    checkEquip(equip) {
      console.log({ equip });
      const count = this.equips.filter((e) => e.ID == equip.ID)[0].count;
      console.log({ count });
      if (Number(count) <= 0) {
        equip.ID = "";
        alert("Данного оборудования нет на складе!");
      }
    },
  },
  watch: {
    selectAction(newAction) {
      if (newAction == "Cнятие" && !this.selectType) {
        this.disable = true;
      } else {
        this.disable = false;
      }
      console.log({ newAction });
      this.saveItems = [];
      if (this.item) {
        this.saveItems.push(this.item);
      }
    },
    selectType(newAction) {
      if (newAction) {
        this.disable = false;
      } else {
        this.disable = true;
      }
    },
  },
};
</script>

<style scoped>
.col {
  margin: 0;
  padding: 0;
  margin-right: 5px;
}

.v-application p:not(:last-child) {
  margin-bottom: 0;
}

.machine__description {
  margin-bottom: 16px;
}
</style>
